export const APPCUES_ID = {
    CLICKABLE_FILTER_ICON: 'CLICKABLE_FILTER_ICON',
};
